import React, { useState, useEffect } from 'react';
import { Input } from '../../ui/input';

export function InlineEditNumber({ 
  value, 
  min = 10, 
  max = 3600, 
  onSave 
}: { 
  value: number | null | undefined; 
  min?: number; 
  max?: number; 
  onSave: (value: number) => void;
}) {
  const safeValue = value ?? 0;
  const [editing, setEditing] = useState(false);
  const [editValue, setEditValue] = useState(safeValue.toString());

  useEffect(() => {
    setEditValue(safeValue.toString());
  }, [safeValue]);

  const handleSave = () => {
    const numValue = Number(editValue);
    if (numValue >= min && numValue <= max && !isNaN(numValue)) {
      onSave(numValue);
      setEditing(false);
    } else {
      // Reset to original value if invalid
      setEditValue(safeValue.toString());
      setEditing(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setEditValue(safeValue.toString());
      setEditing(false);
    }
  };

  const numValue = Number(editValue);
  const isValid = !isNaN(numValue) && numValue >= min && numValue <= max;

  if (editing) {
    return (
      <Input
        type="number"
        min={min}
        max={max}
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        className={`w-20 h-7 text-sm ${!isValid ? 'border-destructive-action focus-visible:ring-destructive-action focus-visible:ring-2' : ''}`}
        autoFocus
      />
    );
  }

  return (
    <button
      onClick={() => setEditing(true)}
      className="px-2 py-1 hover:bg-gray-100 rounded text-sm"
    >
      {safeValue}
    </button>
  );
}

